import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';
import { Pastille } from '../components/ui/Primitives';

export interface DashboardAdministratifData {
  compteurs: {
    dossiersEnCours: number;
    dossiersIncomplets: number;
    piecesAVerifier: number;
    documentsAGenerer: number;
    rupturesAnnee: number;
    tauxRupture: number;
  };
  taches: {
    id: string;
    titre: string;
    sousTitre: string;
    statut: string;
    ton: Parameters<typeof Pastille>[0]['ton'];
    page: string;
  }[];
  accesRapides: {
    id: string;
    titre: string;
    sousTitre: string;
    page: string;
  }[];
  alertes: {
    id: string;
    titre: string;
    sousTitre: string;
    ton: 'warning' | 'danger' | 'info';
  }[];
}

export function useDashboardAdministratif(site: string) {
  const parametres = new URLSearchParams({ site });
  return useQuery({
    queryKey: ['dashboard', 'administratif', site],
    queryFn: () => appelApi<DashboardAdministratifData>(`/dashboard/administratif?${parametres.toString()}`),
  });
}
